export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL
export const API_URL = process.env.REACT_APP_API_URL
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN
export const GOOGLE_ANALYTICS_TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID
export const MOCK_API = process.env.REACT_APP_MOCK_API === 'true'
export const RELEASE_ENV = process.env.REACT_APP_RELEASE_ENV || 'development'
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY
export const FIREBASE_AUTHDOMAIN = process.env.REACT_APP_FIREBASE_AUTHDOMAIN
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID
export const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY
